/**
 * "From your In the game badge": where a card came from, one line.
 *
 * The backend stores an `origin` on every card it grants (kind, a label that
 * completes "From …", and a ref) and fills it in for older cards too
 * (modules/cards/services/cardOrigin.ts). The fallback below covers a
 * response from a backend that predates the field.
 */
import type { CardOrigin, CardSource } from "../types/cardTypes";

const SOURCE_LABEL: Record<CardSource, string> = {
  daily_drop: "the card drop",
  milestone: "a milestone",
  purchase: "a purchase",
  gift: "a gift",
  event: "an event",
  game: "the agent game",
  admin: "the house",
  quiz: "the AOTD guessing",
  badge: "a badge",
};

/** The line for a card, an offer or a tile; null when nothing says where it came from. */
export function cardOriginLine(card: {
  origin?: CardOrigin | null;
  source?: CardSource | null;
}): string | null {
  const label = card.origin?.label?.trim() || (card.source ? SOURCE_LABEL[card.source] : "");
  return label ? `From ${label}` : null;
}
